export default class Basket {
    constructor (dto) {
        this.id = -1;
        this.name = '';
        this.conditionStr = '';
        this.displayConditionStr = '';
        this.roleTypeIDs = [];
        this.contentTypeIDs = [];
        this.orderAsc = false;

        if (dto) {
            this.id = dto.id;
            this.name = dto.name;
            this.conditionStr = dto.conditionStr;
            this.displayConditionStr = '';
            this.roleTypeIDs = dto.roleTypeIDs.map(x => x + '');
            this.contentTypeIDs = dto.contentTypeIDs.map(x => x + '');
            this.orderAsc = dto.orderAsc;
        }
    }

    toDto () {
        return {
            Id: this.id,
            Name: this.name,
            ConditionStr: this.conditionStr,
            RoleTypeIDs: this.roleTypeIDs.map(x => parseInt(x)),
            ContentTypeIDs: this.contentTypeIDs.map(x => parseInt(x)),
            OrderAsc: this.orderAsc,
        };
    }
}
